/* exported timeOffset, incWaitCounter, sGetContactsData, updateDomainUser */
/* global CallCenterGraphs, NSContactSearch, NSDockRoster, getMMss, subscribeOnce, updaterUser,
 getSecDiffUtc, durationCounter */
var timeOffset = 0;

/**
 * The dock renders its roster virtually through NSDockRoster (only visible rows
 * exist in the DOM), so presence updates must go through its data model instead
 * of the legacy row-by-row DOM updates. Pages that still server-render contact
 * rows (popout, agents) keep the DOM path.
 */
function dockRosterActive() {
  return typeof NSDockRoster !== 'undefined' && NSDockRoster.isActive();
}

function updateDomainUser(data) {
  var domain = data.domain.replace('.', '-').replace('.', '-')
    .replace('.', '-')
    .replace('.', '-');
  var rowId = 'user-' + data.user;
  var cRow = data.user + '-' + domain;
  var idRow = '#' + data.user + '-' + domain + '-message';
  var id = idRow + ' .user-message';
  var contactId = '#message-' + cRow;

  $(id).data('last_update', data.last_update);
  $(id).attr('last_update', data.last_update);

  // Define uid from data
  var uid = data.user + '@' + data.domain;
  var status = data.portal_status;

  if (status != null && status != '' && status != ' ') {
    status = _(status);
  }

  /**
   * Create row matching html markup from dock.ctp
   * Private function scoped to updateDomainUser
   */
  function createMessageRow() {
    var row = document.createElement('tr');

    row.classList.add('contact-row-msg');

    var td = document.createElement('td');

    row.appendChild(td);

    var tdStatus = document.createElement('td');

    tdStatus.classList.add('contact-status-msg');
    row.appendChild(tdStatus);

    var tbody = document.querySelector('table#contacts-table [uid="' + uid + '"] tbody');

    if (tbody && typeof tbody != 'undefined') {
      tbody.appendChild(row);
    }

    return row;
  }

  /**
   *  Set the status of the contact in the panel using uid attribute selector
   *  Private function scoped to updateDomainUser
   */
  function setStatus() {
    // Return immediately for no uid
    if (!uid || typeof uid === 'undefined') {
      return;
    }

    // List of possible status strings considered empty
    var empty = ['undefined', 'null', '', ' ', '&nbsp;'];

    // Selectors based on current HTML markup / classes
    var row = document.querySelector('table#contacts-table [uid="' + uid + '"] tr.contact-row-msg');

    // No message row available in markup, then create one
    if (!row || typeof row === 'undefined') {
      row = createMessageRow();
    }

    var contact = row.querySelector('.contact-status-msg');

    // Toggle hide class - If status is not falsy or in empty array show the row
    if (status && empty.indexOf(status) === -1) {
      $(row).show();
    } else {
      $(row).hide();
    }

    contact.innerHTML = status;
  }

  if (dockRosterActive()) {
    // Update the roster's data model (it patches any rendered row itself).
    NSDockRoster.applyPresence(data.user, data.presence, status);
  } else {
    setStatus();
  }

  $(id).text(status);
  $(contactId).text(status);

  if (typeof status == 'undefined'
    || status == null
    || status == 'null'
    || status == ''
    || status == ' '
    || status == '&nbsp;'
    || status == 'null'
  ) {
    $(idRow).hide();
    $(idRow).attr('style', 'display: none;');
    $(id).text('');
    $(id).hide();
  } else {
    $(idRow).show();
  }

  if ($('#agents-table').length) {
    if (typeof CallCenterGraphs.processAgentTotals === 'function') {
      CallCenterGraphs.processAgentTotals();
    }
  }

  // update status here for recents as well
  var contactRecentId = $('.presence-recent-' + data.user);

  if (contactRecentId.length > 0) {
    $(contactRecentId).removeClass('open closed inuse progressing alerting held inactive');
    $(contactRecentId).addClass(data.presence);
  }

  // The DOM updates below still run with the roster active: pages like the
  // contacts index render their own #contact-* elements that need them. The
  // dock's own rows are patched by NSDockRoster, so these are no-ops there.
  var $contact = $('#contact-' + data.user + '-' + domain);
  var contactRow = $contact.parent()
    .parent();
  var availIndex;

  $contact.removeClass('open closed inuse progressing alerting held inactive');
  $contact.addClass(data.presence);

  // set availability index for sorting
  availIndex = 'a';

  // if user has no device registered
  if (data.presence == 'inactive' || data.presence == '') {
    availIndex = 'b';
  }

  // setting presence attr on contact-row  used by dock.ctp
  $('#' + rowId ).attr('presence', data.presence);

  contactRow.attr('presence', data.presence);
  contactRow.data('availindex', availIndex);
  $('#user-' + data.aor_user).data('availindex', availIndex);

  // sort the contacts table after updating presence and availIndex
  if (dockRosterActive()) {
    NSDockRoster.receivedSocketUpdate();
  } else if (typeof NSContactSearch.receivedSocketUpdate == 'function') {
    NSContactSearch.receivedSocketUpdate();
  }
}

function incWaitCounter() {
  $('.wait_counter').each(
    function () {
      var sec = $(this).data('wait-sec');

      if (sec != 0 || sec != '0') {
        sec = parseInt(sec, 10) + 1;
        $(this).data('wait-sec', '' + sec);
        $(this).text(getMMss(sec));
      } else {
        $(this).text('-');
      }
    }
  );

  setTimeout(incWaitCounter, 1000);
}

var contactsSocketHandlersBound = false;

/**
 * Bind the contacts presence socket handlers exactly once. Registering these
 * inside sGetContactsData() meant every call (dock plus per-view invocations)
 * and every socket reconnect stacked another handler, so each presence event
 * was processed - and the contacts table re-sorted - multiple times.
 */
function bindContactsSocketHandlers() {
  if (contactsSocketHandlersBound || typeof socket == 'undefined') {
    return;
  }

  contactsSocketHandlersBound = true;

  socket.on('contacts-domain', function (data) {
    updateDomainUser(data);
  });

  // updates user currently logged in
  socket.on('contacts-user', function (data) {
    updaterUser(data);
  });
}

function sGetContactsData(type, domain, filter) {
  if (typeof socket == 'undefined') {
    return;
  }

  var options = {
    domain: domain,
    type: 'contacts'
  };

  if (typeof filter != 'undefined' && filter != '' && filter != '*') {
    options.filter = filter;
  }

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscribeOnce(options);
    });

  bindContactsSocketHandlers();
}

$(function () {
  if (typeof servertime != 'undefined') {
    timeOffset = getSecDiffUtc(servertime);
  }

  setInterval(durationCounter, 1000);
});
